import SmsIcon from '@mui/icons-material/Sms';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { getFullURL, isMobileDevice } from './shareUtils';

export const SMSButton = ({ url, text, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const shareUrl = url || getFullURL();
  const shareText = text ? `${text} ${shareUrl}` : shareUrl;
  const isMobile = isMobileDevice();
  const isMac = typeof navigator !== 'undefined' && navigator.platform.includes('Mac');

  const handleShare = () => {
    // For both macOS and mobile devices, we can use the sms:// URL scheme
    // This will open the Messages app on macOS or the SMS app on mobile

    // Format the SMS URL according to Apple's URL scheme guidelines
    // On both macOS and mobile devices, the format is the same
    const smsUrl = `sms:?&body=${encodeURIComponent(shareText)}`;

    if (isMobile) {
      // On mobile, it's best to use window.location.href to ensure proper app opening
      window.location.href = smsUrl;
    } else {
      // On desktop, open in new window/tab
      window.open(smsUrl, '_blank');
    }
  };

  return (
    <ShareButtonBase
      icon={<SmsIcon />}
      label={intl.formatMessage({ id: 'ShareActions.sms', defaultMessage: 'SMS' })}
      url={shareUrl}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      onClick={handleShare}
      text={text}
      {...rest}
    />
  );
};

SMSButton.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
};

SMSButton.defaultProps = {
  url: '',
  text: '',
};
